// @flow
import * as React from 'react';
import { EmptyCard } from 'components';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import AsyncValues, { type AsyncValueType } from 'lib/async-value';
import ClientSelectMenu from './ClientSelectMenu';
import { fetchClients } from './clientsActions';
import { selectClientCatalog } from './catalogActions';
import ClientFromUrl from './ClientFromUrl';

import saga from './saga';
import reducer, { type ClientCatalogState } from './reducer';
import { injectSaga, injectReducer } from 'store';

injectSaga(saga);
injectReducer(reducer);

type BaseProps = {
  clientId: Id,
  catalogId: Id,
  userProfiles: AsyncValueType<Array<*>>,
  expertUserProfiles: AsyncValueType<Array<*>>,
  properties: AsyncValueType<Map<string, *>>,
  alertConfigs: AsyncValueType<Map<string, *>>,
  catalogs: ClientCatalogState,
};

export type ClientProps = BaseProps & {
  selectClientCatalog: number => void,
};

// $FlowFixMe
export const ClientContext = React.createContext(null);

type StateProps = BaseProps & {
  clients: ?AsyncValueType<Array<MerchantGroupBlob>>,
};

type OwnProps = {
  render?: ClientProps => *,
  children: React.Node,
  onClientChange?: Function,
};

type DispatchProps = {
  fetchClients: typeof fetchClients,
  selectClientCatalog: number => void,
};

type Props = OwnProps & StateProps & DispatchProps;
type State = { clientProps: ?ClientProps };

class ClientProvider extends React.Component<Props, State> {
  state = {
    clientProps: null,
  };

  static getDerivedStateFromProps(nextProps: Props): State {
    const {
      clientId,
      catalogId,
      userProfiles,
      expertUserProfiles,
      alertConfigs,
      properties,
      catalogs,
      clients,
      selectClientCatalog,
    } = nextProps;

    const clientProps =
      nextProps.clientId != null
        ? {
            clientId,
            catalogId,
            userProfiles,
            expertUserProfiles,
            alertConfigs,
            properties,
            catalogs,
            clients,
            selectClientCatalog,
          }
        : null;

    return {
      clientProps,
    };
  }

  componentDidMount() {
    if (!this.props.clients) {
      this.props.fetchClients(this.props.clientId);
    }
  }

  render() {
    const { clients, children } = this.props;

    if (!Array.isArray(clients)) {
      return <EmptyCard message="Fetching available Merchant Groups..." />;
    }
    if (clients instanceof Error) {
      return <EmptyCard message="Could not load Merchant Groups" />;
    }

    return (
      <ClientContext.Provider value={this.state.clientProps}>
        {children}
      </ClientContext.Provider>
    );
  }
}

export function RequireClientSelection() {
  return (
    <div className="pt2 center" style={{ width: '30rem' }}>
      <h2 className="normal sans-serif f4 gray mb2">
        Select a Merchant Group to Continue
      </h2>
      <ClientSelectMenu hideButton={true} />
    </div>
  );
}

const ConnectedClientProvider = connect(
  (state): StateProps => {
    const clientId = state.clients.currentClient;
    let properties = AsyncValues.Pending;

    if (Map.isMap(state.clientProperties)) {
      properties = state.clientProperties;
    } else if (state.clientProperties instanceof Error) {
      properties = state.clientProperties;
    }

    return {
      clientId,
      properties,
      catalogId: state.clientCatalogs.currentCatalog,
      userProfiles: state.clientUserProfiles,
      expertUserProfiles: state.clientExpertUserProfiles,
      alertConfigs: state.clientModerationAlertConfig,
      catalogs: state.clientCatalogs.catalogs,
      clients: state.clients.clients,
    };
  },
  { fetchClients, selectClientCatalog }
)(ClientProvider);

export default function(props: OwnProps) {
  return (
    <ClientFromUrl>
      {() => <ConnectedClientProvider {...props} />}
    </ClientFromUrl>
  );
}



// WEBPACK FOOTER //
// ./src/containers/client/ClientProvider.js